import { useLayoutEffect } from 'react';
import RnEventHandler from 'src/utils/RnEventHandler';

interface IUserProfile {
  userId?: string;
  email?: string;
  nickName?: string;
  deviceId?: string;
}
export default function useRnEventListener(props?: IUserProfile) {
  useLayoutEffect(() => {
    if (!window.ReactNativeWebView) {
      const handleMessage = (event: MessageEvent) => {
        if (event.origin === 'https://www.frism.io') { // 보안상의 이유로 출처를 확인
          if (event.data.type === 'requestHeight') {
            sendHeight();
          }
        }
      };

      const sendHeight = () => {
        const height = document.documentElement.scrollHeight || document.body.scrollHeight;
        const divElement = document.querySelector('div.sc-gsnTZi.fCJLFv');
        window.parent.postMessage({ type: 'height', height: divElement?.scrollHeight ?? height }, 'https://www.frism.io');
      };

      // 메시지 이벤트 리스너 등록
      window.addEventListener('message', handleMessage);

      // 컴포넌트 언마운트 시 이벤트 리스너 정리
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
    RnEventHandler.addMessageListener((e: any) => {
      // RN에서 보내준 e객체에서 파싱해서 데이터를 꺼내서 사용한다.
      let message;
      try {
        message = JSON.parse(e.data);
        if (message.origin !== 'frism-webview') {
          throw new Error('frism-webview와 상관없는 이벤트입니다.');
        }

        console.log('@ -> RN에서 보낸 메세지 확인하기 : ', message);
      } catch (error) {
        // 상관 없는 메세지 이벤트는 무시
        console.log(
          '🚀 → file: useRnEventListener.ts → line 25 → error',
          error,
        );
      }
    });
  }, []);
}
